import { connect } from 'react-redux'

import { DataTable } from './data-table'
import dataTableSelector from './data-table.selector'

export default connect(dataTableSelector, null, null, {
  forwardRef: true
})(DataTable)
